import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { CONFIG } from 'config';
import { Box, Skeleton } from 'components/base';
import { LIBRARIES } from 'constant';

export const GoogleMapsLoader = ({
  children,
  loader,
}: {
  children: React.ReactNode;
  loader?: React.ReactNode;
}) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: CONFIG.MAP_API,
    libraries: LIBRARIES,
  });

  if (loadError) return <Box>Error loading Google Maps</Box>;

  return isLoaded ? (
    <Box
      sx={{
        '& .pac-container': {
          display: 'block',
          zIndex: 999999,
        },
        '& .pac-container .pac-logo': {
          display: 'block',
          zIndex: 999999,
        },
      }}
    >
      {children}
    </Box>
  ) : (
    <>{loader || <Skeleton variant="rounded" width="100%" height="100%" />}</>
  );
};
